<template>
  <div
          @click="select"
          class="clickable option"
          :class="{
          selected: $root.shape === option.value,
          hover: hover,
          }"
          :title="option.value"
          :alt="option.value"
  >
    <img :src="option.img">
    <div class="description">{{option.description}}</div>
    <div class="name">{{$root.shapeToDisplayName(option.value)}}</div>
    <div
            class="info"
            title="info"
            @click.stop="toggle_hover"
    >
      <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 490 490"
      >
        <path
                fill="none"
                stroke="#000"
                stroke-width="36"
                stroke-linecap="round"
                d="m280,278a153,153 0 1,0-2,2l170,170m-91-117 110,110-26,26-110-110"
        />
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        hover: false,
      }
    },
    props: [
      'option',
    ],
    methods: {
      toggle_hover(){
        this.hover = !this.hover;
      },
      select(){
        this.$root.shape = this.option.value;
        this.$root.step++;
      },
    }
  }
</script>

<style lang="less" scoped>
  .option {
    display: inline-block;
    position: relative;
    margin: 15px;
    padding: 15px;

    width: 250px;
    height: 250px;
    box-sizing: border-box;

    > img {
      max-height: 190px;
      max-width: 100%;
    }

    .name {
      position: absolute;
      height: 30px;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 20;
    }

    .description {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
      z-index: 10;
      opacity: 0;
      background-color: #fa1f97;
      color: white;
      padding: 50px 15px 50px 15px;
    }

    .info {
      position: absolute;
      padding: 10px;
      left: 0;
      bottom: 0;
      z-index: 30;

      svg {
        width: 30px;
        height: 30px;
      }

      path{
        stroke: black;
      }
    }

    .name, .description, path {
      transition-property: all;
      transition-duration: .5s;
    }

    &:hover, &.hover {
      .description {
        opacity: 0.9;
      }

      .name, .description, .info {
        color: white;

        path{
          stroke: white;
        }
      }
    }
  }
</style>
